<template>
  <div>
    <div class="demo-padding">
      <div class="head">
        <span class="title">常见问题</span>
        <span class="content" @click="goQuestionsPage">
          <span class="more">更多</span>
          <img
            class="arrow"
            src="https://p0.meituan.net/wxapp/3753cd32654788440bce014181879cf5342.png"
            alt=""
          />
        </span>
      </div>
      <div class="content-pro">
        <div v-for="(item, index) in questionList" :key="index">
          <question-list :question-item="item" class="question-item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { analyticConfig, analytics, bridge, getUrl } from '@/common';
import QuestionList from '../../../components/QuestionList.vue';

export default Vue.extend({
  name: 'CommonProblem',
  components: {
    QuestionList,
  },
  props: {
    questionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSelect: false,
    };
  },
  computed: {
    getRightAccess(): string {
      if (this.showSelect) {
        return 'access-top';
      }
      return 'access-bottom';
    },
  },
  created() {
    // console.log(this.subModule);
    // 子标题的曝光埋点
  },
  methods: {
    onSwitch() {
      this.showSelect = !this.showSelect;
    },
    goQuestionsPage() {
      analytics.click(analyticConfig.questionListMoreMc);
      bridge.openPage(getUrl('/faq.html?scene=faq'));
    },
  },
});
</script>

<style lang="less" scoped>
.demo-padding {
  padding: 0 0.24rem;
  background: #ffffff;
  border-radius: 0.24rem;
  margin-top: 0.2rem;
  padding-top: 0.36rem;
  padding-bottom: 0.3rem;
}
.head {
  display: flex;
  align-items: center;
  position: relative;
  .title {
    opacity: 0.9;
    font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 0.32rem;
    color: #000000;
    letter-spacing: 0;
    line-height: 0.32rem;
    font-weight: bold;
  }
  .content {
    flex-grow: 1;
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    .more {
      opacity: 0.4;
      font-family: PingFangSC-Regular, sans-serif;
      font-size: 0.24rem;
      color: #000000;
      letter-spacing: 0;
      text-align: right;
      line-height: 0.24rem;
      font-weight: 400;
      padding-right: 0.04rem;
    }
    .arrow {
      width: 0.24rem;
      height: 0.24rem;
    }
  }
}
.content-pro {
  margin-top: 0.15rem;
}
</style>
